// @flow
import { connect } from 'react-redux';

import CardLoge from 'components/fragments/card/CardLoge';
import type { StateType } from 'types/Actions';
import type { StateProps } from 'components/fragments/card/CardLoge';

export default connect(
  (state: StateType): StateProps => ({
    userPref: state.userState.userPref
  })
)(CardLoge);
